import { formatDate, formatMoney } from "utils";

export async function generatePrintNoRecordHtml(noRecordDetails) {
    return `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <link rel="icon" type="image/png" href="/assets/logos/logo.png" />
      <head>
        <meta charset="UTF-8">
        <title>GOTT - Gestor de Operações de Transito e Transporte</title>
        <style>
          body {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            background-color: #fff;
            margin: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 4px;
          }
          td {
            border: 1px solid #CCC;
            padding: 10px;
            vertical-align: top;
            line-height: 1.42857143;
            width: 33.33333333%;
          }
          small {
            margin-top: 1px;
            margin-bottom: 10px;
            display: block;
            font-size: 14px;
            line-height: 8px;
          }
          strong {
            font-weight: bold !important;
          }
          p {
            margin: 0 !important;
          }
          h1 {
            font-weight: 500;
            line-height: 1.1;
            margin: 0.67em 0;
          }
          h4 {
            margin-top: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 1.1;
            font-weight: bold;
          }
          .text-center {
            text-align: center;
          }
          .highlighted {
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            margin: 5px 0;
            text-decoration: underline;
            text-transform: uppercase;
          }
          .head-text {
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            padding: 0 15px;
          }
          .footer-text {
            display: flex;
            justify-content: space-between; 
            font-size: 12px;
          }
        
          .column {
            display: flex;
            flex-direction: column; 
          }
        
          .column b {
            font-weight: bold;
          }
          
          .column strong {
            font-weight: bold;
            font-style: italic;
          }
          
          .column.left {
            text-align: left;
          }
          
          .column.right {
            text-align: right;
          }
          
          .align-middle {
            vertical-align: middle !important;
          }
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
            }
            header, footer {
              display: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="cape" style="max-width: 800px; margin: 16px">
          <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 8px;">
            <div class="image-container" style="width: 25%; text-align: center; transform: translateX(-15px);">
              <img src="/assets/logos/${noRecordDetails?.company_logo}" width="100%"  alt=""/>
            </div>
            <div class="head-text" style="text-align: center;">
              <strong>${noRecordDetails?.company_state_description}</strong><br/>
              <strong>${noRecordDetails?.company_owner_name}</strong><br/>
              <strong>${noRecordDetails?.company_name}</strong>
            </div>
            <div class="image-container" style="width: 25%; text-align: center;">
              <img src="/assets/logos/${noRecordDetails?.company_owner_logo}" width="100%"  alt=""/>
            </div>
          </div>
    
          <h4 class="text-center">DEMONSTRATIVO DE MULTA DE TRÂNSITO (*)</h4>
    
  
          <table>
            <tr>
              <td colspan="3"><small>Proprietário</small> <strong>${noRecordDetails?.vehicle.nomeProprietario ? noRecordDetails?.vehicle.nomeProprietario : ''}</strong></td>
            </tr>
            <tr>
              <td colspan="3">
                  <small>Endereço</small>
                  <strong>
                    ${noRecordDetails?.vehicle.enderecoImovelProprietario ? noRecordDetails?.vehicle.enderecoImovelProprietario : ''}
                    ${noRecordDetails?.vehicle.numeroImovelProprietario ? noRecordDetails?.vehicle.numeroImovelProprietario : ''},
                    ${noRecordDetails?.vehicle.bairroImovelProprietario ? noRecordDetails?.vehicle.bairroImovelProprietario : ''},
                    ${noRecordDetails?.vehicle.cepImovelProprietario ? noRecordDetails?.vehicle.cepImovelProprietario : ''}
                  </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2"><small>Município</small> <strong>${noRecordDetails?.vehicle.cidadeImovelProprietario ? noRecordDetails?.vehicle.cidadeImovelProprietario : ''}</strong></td>
              <td><small>UF</small> <strong>${noRecordDetails?.vehicle.ufImovelProprietario ? noRecordDetails?.vehicle.ufImovelProprietario : ''}</strong></td>
            </tr>
            <tr>
              <td><small>Placa</small> <strong>${noRecordDetails?.vehicle.placa ? noRecordDetails?.vehicle.placa : ''} ${noRecordDetails?.vehicle.ufPlaca ? noRecordDetails?.vehicle.ufPlaca : ''}</strong></td>
              <td><small>Marca/Modelo</small> <strong>${noRecordDetails?.vehicle.descricaoMarcaModelo ? noRecordDetails?.vehicle.descricaoMarcaModelo : ''}</strong></td>
              <td><small>Adesão SNE</small> <strong>${noRecordDetails?.sne_date ? noRecordDetails?.sne_date : 'NÃO ADERIU'}</strong></td>
            </tr>
          </table>
    
          <h4 class="text-center">DISCRIMINAÇÃO</h4>
          <table>
            <thead>
              <th>Data da Infração</th>
              <th>Núm. AIT</th>
              <th>Tipo da Infração (***)</th>
              <th>Vencimento</th>
              <th>Valor (**)</th>
              <th>Situação</th>
            </thead>
            
            ${noRecordDetails?.traffic_violations.map(violation => `
                <tr>
                  <td>${violation.data_infracao ? formatDate(violation.data_infracao) : ' - '}</td>
                  <td>${violation.numero_ait ? violation.numero_ait : ' - '}</td>
                  <td>${violation.id_tipo_infracao?.violation_type_description ? violation.id_tipo_infracao.violation_type_description : ' - '}</td>
                  <td>${violation.data_vencimento_integracao_pagamento ? formatDate(violation.data_vencimento_integracao_pagamento) : ' - '}</td>
                  <td>${violation.valor_tipo_infracao ? formatMoney(violation.valor_tipo_infracao): ' - '}</td>
                  <td>${violation.situacao ? violation.situacao : ' - '}</td>
                </tr>
              `).join('')}
          </table>
          
          <div class="footer-text">
              <div class="column left">
                <strong>(*) Salvo multas em tramitação</strong>
                <b>(**) Valor total das multas em aberto: R$ ${noRecordDetails.value_to_pay ? formatMoney(noRecordDetails.value_to_pay) : ' 0,00 '}</b>
                <b>(***) Pontuação</b>
              </div>
        
              <div class="column right">
                <b>Total geral de multas: ${noRecordDetails.valid_traffic_violations ? noRecordDetails.valid_traffic_violations : ' 0 '}</b>
                <b>Total de multas em aberto: ${noRecordDetails.not_paid_traffic_violations ? noRecordDetails.not_paid_traffic_violations : ' 0 '}</b>
              </div>
          </div>
        </div>
      </body>
      </html>
  `;
}
